module.exports = __webpack_public_path__ + "media/images/online_ordering_settings_images/theme1-f2e42f50a98da0574ba1de20f7d89602.png";